module.exports = __webpack_public_path__ + "img/8.cf7987ea.png";